export default "__VITE_ASSET__70156dc7__"